export default __webpack_public_path__ + "static/media/nutrition1.c6bcfe07.png";